import React from "react";

import { PagesContainer } from "../../../containers";
import { UpdatePassword } from "../../../screens";

const LoginInfo = props => {
  return (
    <PagesContainer {...props}>
      <UpdatePassword {...props} />
    </PagesContainer>
  );
};

export default LoginInfo;
